/* src/app/shared/components/entity-dropdown-picker/entity-dropdown-picker.component.css */
:host {
  display: block;
  min-width: 0;
}
:host ::ng-deep .p-iftalabel {
  width: 100%;
}
:host ::ng-deep .p-dropdown {
  width: 100%;
  min-width: 0;
}
:host ::ng-deep .p-dropdown-panel {
  min-width: 100%;
}
:host ::ng-deep .p-inputgroup {
  width: 100%;
  align-items: stretch;
}
:host ::ng-deep .p-inputgroup .filter-loading-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  min-width: 2rem;
  height: 100%;
  color: var(--text-color-secondary, #6b7280);
  font-size: 0.875rem;
  line-height: 1;
  padding: 0 0.25rem;
}
:host ::ng-deep .p-inputgroup .filter-loading-indicator .pi {
  animation-duration: 0.8s;
}
/*# sourceMappingURL=entity-dropdown-picker.component-NVYXOYK5.css.map */
